var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"lock-screen-btn-con"},[_c('Badge',{attrs:{"count":_vm.Count},nativeOn:{"click":function($event){return _vm.toReminder.apply(null, arguments)}}},[_c('i',{staticClass:"iconfont",staticStyle:{"font-size":"20px"}},[_vm._v("")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }